export const normalizePhoneNumber = (value) => {
  let phoneNumber = value.replace(/\D/g, "");
  phoneNumber = phoneNumber.replace(/^(0|62)/, "");
  return phoneNumber
};

export const isAlphaNumeric = (str) => {
  // Regex to check valid
  // alphanumeric string
  // cannot contain special chars such @ or #
  let regex = new RegExp(/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$/);

  // if str
  // is empty return false
  if (str == null) {
    return false;
  }

  // Return true if the str
  // matched the ReGex
  if (regex.test(str) == true) {
    return true;
  } else {
    return false;
  }
};

export const isContainStringNumber = (str) =>
  !!str.match(/^(?=.*[A-Za-z])(?=.*\d)/);

export const operatorDetector = (phone) => {
  const prefix = phone.slice(0, 4);
  if (["0831", "0832", "0833", "0838"].includes(prefix)) return "axis";
  if (["0895", "0896", "0897", "0898", "0899"].includes(prefix)) return "three";
  if (["0817", "0818", "0819", "0859", "0878", "0877"].includes(prefix))
    return "xl";
  if (["0814", "0815", "0816", "0855", "0856", "0857", "0858"].includes(prefix))
    return "indosat";
  if (
    [
      "0812",
      "0813",
      "0852",
      "0853",
      "0821",
      "0823",
      "0822",
      "0851",
      "0811",
    ].includes(prefix)
  )
    return "telkomsel";
  if (
    [
      "0881",
      "0882",
      "0883",
      "0884",
      "0885",
      "0886",
      "0887",
      "0888",
      "0889",
    ].includes(prefix)
  )
    return "smartfren";
  return null;
};

export const phoneNumberValidation = (phone) => {
  return lengthValidation(phone) && !!operatorDetector(phone);
};

export const lengthValidation = (phone) => {
  if (!phone || !/^08[1-9][0-9]{6,10}$/.test(phone)) {
    return false;
  }
  return true;
};

export const isNumberValidation = (number) => {
  const numberValidation = /^[0-9\b]+$/;

  return numberValidation.test(number);
};
